import React from "react";
import "./Ruko.scss";
import data from "./data.json";
import Card from "../../Component/Card Ruko/CardRuko";
import Devantimages from "../../Media/Ruko Kotwis/Devant/Devant";
import Shophousesimages from "../../Media/Ruko Kotwis/Shophouse/Shophouses";
import NorthSquareimages from "../../Media/Ruko Kotwis/Northsquare/NorthSquare";

const imageMap = {
  Devantimages,
  Shophousesimages,
  NorthSquareimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="ruko" className="ruko">
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
